import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './LogViewer.css'; // Import the CSS file

const LogViewer = () => {
    const { type } = useParams();
    const [date, setDate] = useState('');
    const [logContent, setLogContent] = useState('');

    const fetchLog = async () => {
        try {
          const URL= sessionStorage.getItem('Url')
            // const response = await axios.get(`https://live.asktek.net/PadmaIOG_api/logs/${type}/${date}`);
            const response = await axios.get(`${URL}logs/${type}/${date}`);
            setLogContent(response.data);
        } catch (error) {
            setLogContent('Error fetching log file. Please ensure the file exists.');
        }
    };

    return (
        <div className="logviewer-container">
            <div className="logviewer-content">
                <div className="back-icon-container">
                    <button
                        onClick={() => window.history.back()}
                        className="back-icon"
                    >{`< Back`}</button>
                </div>
                <h2 className="logviewer-title">{type} Logs - {sessionStorage.getItem('Project')}</h2>
                <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="logviewer-input"
                />
                <button onClick={fetchLog} className="logviewer-button ">
                    Fetch Logs
                </button>
                <div className="logviewer-output">
                    <pre>{logContent}</pre>
                </div>
            </div>
        </div>
    );
};

export default LogViewer;
